<template>
  <location
    :locationService = locationService
    :transactionService = transactionService
    :productService = productService
  ></location>
</template>

<script>
  // Components
  import Location from '@/components/Common/Rental/Locations/Location'

  // Services
  import locationService from '@/services/licensor/location'
  import transactionService from '@/services/licensor/transaction'
  import productService from '@/services/licensor/product'

  export default {
    components: {
      Location,
    },

    data () {
      return {
        locationService: locationService,
        transactionService: transactionService,
        productService: productService,
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/Locations/Location.vue